import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AgentType } from '../enums/agents.enum';
import { Journey } from '../models/journey.model';
import { JourneyService } from '../services/journey.service';




@Directive({
  selector: '[journeyRestriction]'
})
export class JourneyRestrictionDirective implements OnInit {
  @Input() journeyRestriction: Array<Partial<Journey>> | Partial<Journey> | Array<keyof typeof AgentType> | keyof typeof AgentType;
  @Input('journeyRestrictionJourneyId') JourneyId?: number = null;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private journeyService: JourneyService) { }

  ngOnInit() {
    this.journeyService.journey$.subscribe(() => {
      if (this.journeyService.isProductConfigured(this.journeyRestriction, this.JourneyId)) {
        if (!this.viewContainer.length) this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
